import { CustomSingleSelectModel } from "../../../components/CustomSingleSelect"
import { ColumnChooserModel } from "../../common/ColumnChooserModel"
import { ColumnFilterModel } from "../../common/ColumnFilterModel"

export interface GetYurticiCargoAgreementListPagingAndFilterRequest {
    searchTerm: string
    skip?: number
    take?: number
    currentPage: number
    sortColumn?: string
    sortDirection?: string
    columnChooser: ColumnChooserModel[] | undefined
    selectedAgreementScheme?: CustomSingleSelectModel
    ids?: string[]
    /** Kolon başlıklarının altındaki filtreler. */
    columnFilters: ColumnFilterModel[]
}

export const initialGetYurticiCargoAgreementListPagingAndFilterRequest: GetYurticiCargoAgreementListPagingAndFilterRequest = {
    searchTerm: '',
    skip: 0,
    take: 50,
    currentPage: 1,
    sortColumn: undefined,
    sortDirection: undefined,
    columnChooser: undefined,
    columnFilters: []
}